import { Router, Route, Switch, withRouter } from 'react-router';
import withRole from 'components/Security/withRole';
import DataGridStateContextProvider from 'components/DataGrid/DataGridStateContext';
import {
  ROLE_CREATE_VARIANT,
  ROLE_EDIT_VARIANT,
  ROLE_SHOW_VARIANT,
} from 'helpers/roles';

import List from './List';
import FormVariantsContainer from './components/FormVariants.container';

const Variants = ({ history, match }) => {
  const ListSecured = withRole(ROLE_SHOW_VARIANT, List);
  const CreateForm = withRole(ROLE_CREATE_VARIANT, FormVariantsContainer);
  const EditForm = withRole(ROLE_EDIT_VARIANT, FormVariantsContainer);

  return (
    <DataGridStateContextProvider>
      <Router history={history}>
        <Switch>
          <Route exact={true} path={`${match.url}/`} component={ListSecured} />
          <Route path={`${match.url}/add`} component={CreateForm} />
          <Route path={`${match.url}/edit/:id`} component={EditForm} />
        </Switch>
      </Router>
    </DataGridStateContextProvider>
  );
};

export default withRouter(Variants);
